import { render, staticRenderFns } from "./chat_new.vue?vue&type=template&id=270b4c90&scoped=true&"
import script from "./chat_new.vue?vue&type=script&lang=js&"
export * from "./chat_new.vue?vue&type=script&lang=js&"
import style0 from "./chat_new.vue?vue&type=style&index=0&id=270b4c90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b4c90",
  null
  
)

export default component.exports